export const environment = {
  production: true,
  ria: {
    endpoint: '/'
  }
};
